// extracted by mini-css-extract-plugin
export default {"projectWidgetContainer":"Widgets_projectWidgetContainer__GtYsd","projectWidget":"Widgets_projectWidget__vdkZk","projectTitle":"Widgets_projectTitle__+o33H"};